import { useQuery } from '@tanstack/react-query';
import { adminClient } from '@/lib/adminClient';

export const transactionKeys = {
  all: ['transactions'] as const,
  list: (filters: Record<string, string | number | undefined>) => [...transactionKeys.all, 'list', filters] as const,
  detail: (id: string) => [...transactionKeys.all, 'detail', id] as const,
};

export function useTransactions(filters: {
  accountId?: string;
  context?: string;
  status?: string;
  assetSymbol?: string;
  pageSize?: number;
  pageToken?: string;
}) {
  return useQuery({
    queryKey: transactionKeys.list(filters),
    queryFn: () => adminClient.listTransactions(filters),
  });
}

export function useTransaction(id: string) {
  return useQuery({
    queryKey: transactionKeys.detail(id),
    queryFn: () => adminClient.getTransaction(id),
    enabled: !!id,
  });
}
